export default [
  {
    text: 'Participación en la conferencia científica internacional <a href="https://openreadings.eu/">OpenReadings</a> en Vilna.',
    year: '2026',
  },
  {
    text: 'Membresía en el <a href="https://home.cern/about/who-we-are/our-governance">CERN</a> durante el verano de 2024.',
    year: '2024',
  },
  { text: 'Certificado de idioma inglés Acert B2', year: '2024' },
  {
    text: 'Beca del programa <a href="https://www.stypendia-pomostowe.pl">Becas Puente</a>.',
    year: '2023',
  },
  {
    text: 'Beca otorgada nuevamente bajo el programa de <a href="https://www.podparpackie.edu.pl">Apoyo de becas para estudiantes talentosos</a>.',
    year: '2022',
  },
  {
    text: 'El proyecto <a href="https://soulgraphy.me">Soulgraphy</a> alcanzó las 100.000 visitas en internet.',
    year: '2021',
  },
  {
    text: 'Beca del programa de <a href="https://www.podparpackie.edu.pl">Apoyo de becas para estudiantes talentosos</a>.',
    year: '2020',
  },
  {
    text: 'Galardonado en el concurso nacional de física "Albus" (8º lugar).',
    year: '2019',
  },
  { text: 'Galardonado en el concurso regional de física.', year: '2019' },
  {
    text: 'Doble galardonado en el concurso nacional "Olimpus" de matemáticas (5º lugar) y física (9º lugar).',
    year: '2019',
  },
]
